import React, { useState, useEffect, useRef } from 'react';
import "../alertDialog/styleAlertDialog.css";
import DateRangePicker from "react-bootstrap-daterangepicker";

export const CustomAlertDialogGlobal = ({
    visible,
    title,
    message,
    type = "info",
    icon = null,
    mode = "alert",
    buttonText = "Aceptar",
    cancelText = "Cancelar",
    onAccept,
    onCancel,
    showDatePicker = false,
    minDate = null
}) => {

    const [studyDelivery, setStudyDelivery] = useState("");
    const [dateError, setDateError] = useState("");
    const [datePickerOpen, setDatePickerOpen] = useState(false);

    const dateInputRef = useRef(null);
    const studyDeliveryRef = useRef("");

    useEffect(() => {

        if (!visible || !showDatePicker) {
            return;
        }

        const timer = setTimeout(() => {

            if (dateInputRef.current) {
                const event = new MouseEvent("mousedown", {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });

                dateInputRef.current.dispatchEvent(event);
            }

        }, 500);

        return () => {
            clearTimeout(timer);
        };

    }, [visible, showDatePicker]);

    useEffect(() => {

        if (!visible || !showDatePicker || !datePickerOpen) {
            return;
        }

        const syncCalendarHeight = () => {

            const modal = document.querySelector(
                ".custom-dialog-global-backdrop .alert-dialog-global"
            );

            const calendar = document.querySelector(
                ".daterangepicker.custom-alert-daterangepicker"
            );

            if (!modal || !calendar) {
                return;
            }

            const modalHeight = modal.offsetHeight;

            calendar.style.height = `${modalHeight}px`;
            calendar.style.minHeight = `${modalHeight}px`;
            calendar.style.maxHeight = `${modalHeight}px`;
        };

        const timer = setTimeout(() => {
            syncCalendarHeight();
        }, 50);

        const modal = document.querySelector(
            ".custom-dialog-global-backdrop .alert-dialog-global"
        );

        let resizeObserver = null;

        if (modal) {
            resizeObserver = new ResizeObserver(() => {
                syncCalendarHeight();
            });
            resizeObserver.observe(modal);
        }


        return () => {
            clearTimeout(timer);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }

        };

    }, [
        visible,
        showDatePicker,
        datePickerOpen,
        dateError,
        message
    ]);

    if (!visible) { return null; }
    const styles = {
        info: {
            icon: "fa fa-info-circle",
            color: "#0d6efd"
        },
        success: {
            icon: "fa fa-check-circle",
            color: "#28a745"
        },
        warning: {
            icon: "fa fa-exclamation-triangle",
            color: "#fd7e14"
        },
        error: {
            icon: "fa fa-times-circle",
            color: "#dc3545"
        }
    };

    const currentStyle = styles[type] || styles.info;

    // SELECT FECH
    const handleApplyDate = (event, picker) => {

        const date = picker.startDate.format("YYYY-MM-DD HH:mm");
        studyDeliveryRef.current = date;
        setStudyDelivery(date);
        setDateError("");
    };
    const handleAccept = () => {

        const dateToSave = studyDeliveryRef.current || studyDelivery;
        if (
            showDatePicker &&
            buttonText === "Agregar fecha"
        ) {

            if (!dateToSave) {
                setDateError( "Debes seleccionar una fecha de entrega para generar la orden." );
                return;
            }
            setDateError("");
            onAccept(dateToSave);
            return;
        }

        if (showDatePicker) {
            onAccept(dateToSave);
            return;
        }
        onAccept();
    };

    return (

        <div className={`custom-dialog-global-backdrop ${ datePickerOpen ? "custom-dialog-date-picker-open" : "" }`}>
            <div className={`alert-dialog-global ${showDatePicker ? "alert-dialog-with-date-picker" : ""}`}>
                <div className={`alert-dialog-global-icon alert-dialog-global-icon-${type}`} >
                    <i className={ icon || currentStyle.icon } />
                </div>

                <h2 className="alert-dialog-global-title">
                    {title}
                </h2>
                {
                    //? MESSAGE
                }    

                <div
                    className="alert-dialog-global-text"
                    dangerouslySetInnerHTML={{
                        __html: message
                    }}
                />

                {
                    //?  DATE PICKER
                }    

                {showDatePicker && (

                    <div className="custom-alert-date-input-container">

                        <DateRangePicker
                            initialSettings={{
                                singleDatePicker: true,
                                showDropdowns: true,
                                autoUpdateInput: false,
                                minDate: minDate,
                                timePicker: true,
                                timePicker24Hour: true,
                                parentEl: "body",
                                opens: "right",
                                drops: "down",
                                autoApply: false,
                                locale: {
                                    format: "YYYY-MM-DD HH:mm",
                                    applyLabel: "Aceptar",
                                    cancelLabel: "Cancelar",
                                    daysOfWeek: [
                                        "Dom",
                                        "Lun",
                                        "Mar",
                                        "Mié",
                                        "Jue",
                                        "Vie",
                                        "Sáb"
                                    ],
                                    monthNames: [
                                        "Enero",
                                        "Febrero",
                                        "Marzo",
                                        "Abril",
                                        "Mayo",
                                        "Junio",
                                        "Julio",
                                        "Agosto",
                                        "Septiembre",
                                        "Octubre",
                                        "Noviembre",
                                        "Diciembre"
                                    ]
                                }
                            }}

                            onShow={(event, picker) => {
                                picker.container.addClass(
                                    "custom-alert-daterangepicker"
                                );

                                picker.container.css({
                                    width: "250px",
                                    minWidth: "250px",
                                    maxWidth: "250px"
                                });

                                picker.container
                                    .find(".calendar")
                                    .css({
                                        width: "100%",
                                        maxWidth: "100%",
                                        float: "none"
                                    });

                                picker.container
                                    .find(".calendar-table")
                                    .css({
                                        width: "100%"
                                    });

                                setDatePickerOpen(true);
                            }}
                            onHide={() => {
                                setDatePickerOpen(false);
                            }}
                            onApply={handleApplyDate}
                        >

                            <input
                                ref={dateInputRef}
                                id="custom-alert-date-input"
                                type="text"
                                readOnly
                                value={studyDelivery || ""}
                                className="form-control custom-alert-date-input"
                                placeholder="Fecha de entrega"
                            />

                        </DateRangePicker>


                        {
                            //? ERRORS
                        }    

                        {dateError && (
                            <div className="custom-alert-date-error">
                                <i className="fa fa-exclamation-circle"/>
                                {" "}
                                {dateError}
                            </div>
                        )}
                    </div>

                )}


                {
                    //? BUTTONS
                }            

                <div className="alert-dialog-global-actions">
                    {mode === "confirm" && (
                        <button
                            type="button"
                            className="global-alert-custom-cancel"
                            onClick={onCancel}
                        >
                            {cancelText}
                        </button>
                    )}

                    <button
                        type="button"
                        className={`global-alert-custom-confirm global-alert-custom-confirm-${type}`}
                        onClick={handleAccept}
                    >
                        {buttonText}
                    </button>
                </div>

            </div>

        </div>
    );
};